export default __webpack_public_path__ + "static/media/defect-management.8808adc8.svg";